import React from "react";
import "font-awesome/css/font-awesome.min.css";

const spinner = () => {
  return (
    <div className="loaderWidget">
      <div className="loading">
        <i className="fa fa-spinner fa-spin"></i>
      </div>
    </div>
  );
};
export default spinner;
